'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareTableComponent = CompareTableComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bdcoreData = require('@bd/bdcore-data');

var _bdcoreData2 = _interopRequireDefault(_bdcoreData);

var _actions = require('@bd/bdcore-data/build/Compare/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CompareTableComponent(_ref) {
  var className = _ref.className,
      communities = _ref.communities,
      compare = _ref.compare,
      config = _ref.config,
      dispatch = _ref.dispatch,
      homes = _ref.homes,
      plans = _ref.plans,
      title = _ref.title;
  var type = compare.type;

  return _react2.default.createElement(
    'div',
    { className: className },
    title({ config: config, compare: compare }),
    _react2.default.createElement(
      'div',
      { className: 'CompareTable_tableWrapper' },
      _react2.default.createElement(
        'table',
        { className: 'CompareTable_table' },
        _react2.default.createElement(
          'tbody',
          { className: 'CompareTable_tableBody' },
          (0, _lodash.get)(config, (0, _lodash.get)(compare, 'type') + '.fields', []).map(function (field) {
            return _react2.default.createElement(
              'tr',
              { key: (0, _lodash.get)(field, 'title'), className: 'CompareTable_tableRow' },
              _react2.default.createElement(
                'th',
                { className: 'CompareTable_tableHeader' },
                (0, _lodash.get)(field, 'title')
              ),
              compare.items.map(function (item, index) {
                var renderProps = {
                  item: item,
                  index: index,
                  toggle: function toggle() {
                    return dispatch((0, _actions.toggleCompareItem)({ id: (0, _lodash.get)(item, '_id'), type: type }));
                  }
                };

                if (type === 'communities') {
                  renderProps.homes = homes.filter(function (h) {
                    return h.containedIn === item._id;
                  });
                  renderProps.plans = plans.filter(function (p) {
                    return (0, _lodash.map)((0, _lodash.get)(p, 'communities', []), 'community').includes(item._id);
                  });
                }

                if (type === 'homes') {
                  renderProps.community = communities.find(function (c) {
                    return c._id === item.containedIn;
                  });
                  renderProps.plan = plans.find(function (p) {
                    return p._id === item.plan;
                  });
                }

                return _react2.default.createElement(
                  'td',
                  { key: item._id, className: 'CompareTable_tableData' },
                  (0, _lodash.get)(field, 'render', function () {
                    return null;
                  })(renderProps)
                );
              })
            );
          })
        )
      )
    )
  );
}

CompareTableComponent.propTypes = {
  className: _propTypes2.default.string,
  communities: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  compare: _propTypes2.default.object.isRequired,
  config: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  homes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  plans: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  title: _propTypes2.default.func
};

CompareTableComponent.defaultProps = {
  className: undefined,
  title: function title(_ref2) {
    var compare = _ref2.compare,
        config = _ref2.config;
    return 'Comparing ' + (0, _lodash.get)(config, (0, _lodash.get)(compare, 'type') + '.title', 'Add Config Title');
  }
};

exports.default = (0, _bdcoreData2.default)({
  compare: true,
  communities: true,
  homes: true,
  community: true,
  plans: true
}, {
  required: {
    compare: true,
    communities: true,
    homes: true,
    plans: true
  }
})(CompareTableComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-compare/build/CompareTable.js
// module id = 1090
// module chunks = 0